"use client"
import * as React from "react"
import Box from "@mui/material/Box"
import Tab from "@mui/material/Tab"
import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import { styled } from "@mui/material/styles"
import DangerouslySetInnerHTML from "@src/components/DangerouslySetInnerHTML"
import { useTranslation } from "react-i18next"
import AdditionalInformation from "./additional_information"

const TabHeader = styled(Tab)({
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400,
  opacity: 0.5,
  color: "black",
  textTransform: "none",
  "&.Mui-selected": {
    fontWeight: 700,
    opacity: 1,
    color: "black"
  },
  "@media (max-width: 860px)": {
    fontSize: 14,
    padding: 8
  }
})

const StyledTabPanel = styled(TabPanel)({
  padding: "24px 8px"
})

export default function InfoProduct({ detail }) {
  const [value, setValue] = React.useState("1")
  const { t } = useTranslation()
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box>
          <TabList
            variant="scrollable"
            scrollButtons={false}
            onChange={handleChange}
            aria-label="lab API tabs example"
            TabIndicatorProps={{
              children: <span className="MuiTabs-indicatorSpan" />
            }}
            sx={{
              "& .MuiTabs-indicator": {
                display: "flex",
                justifyContent: "center",
                backgroundColor: "transparent"
              },
              "& .MuiTabs-indicatorSpan": {
                maxWidth: 80,
                width: "100%",
                height: 2,
                backgroundColor: "#000",
                borderRadius: 8
              }
            }}
          >
            <TabHeader label={t("product_details")} value="1" />
            <TabHeader label={t("additional_information")} value="2" />
          </TabList>
        </Box>
        <StyledTabPanel value="1">
          <DangerouslySetInnerHTML html={detail?.description} />
        </StyledTabPanel>
        <StyledTabPanel value="2">
          <AdditionalInformation />
        </StyledTabPanel>
      </TabContext>
    </Box>
  )
}
